import { useState, useEffect } from "react";
import Toolbar from "./components/toolbar";
import { IconButton, Typography } from "@mui/material";
import { Clear } from "@mui/icons-material";
import CustomPDFViewer from "./components/pdf-viewer";
import ThumbNailViewer from "./components/thumbnail-viewer";

function App() {
  const [file, setFile] = useState({
    name: null,
    url: null,
  });
  const [urlParams, setUrlParams] = useState({
    page: null,
    highlight: null,
  });

  // Check for URL parameter on mount and when URL changes
  useEffect(() => {
    const urlString = window.location.search;

    if (urlString) {
      let pdfUrl = null;

      // Parse URL parameters first to get page and highlight/search
      const params = new URLSearchParams(urlString);
      const pageParam = params.get("page");
      const highlightParam = params.get("highlight") || params.get("search");
      const url = params.get("url");

      console.log("Page param:", pageParam);
      console.log("Highlight param:", highlightParam);
      console.log("URL param:", url);
      pdfUrl = url;

      // Store URL params for passing to PDF viewer
      if (pageParam || highlightParam) {
        const pageNumber = pageParam ? parseInt(pageParam) : null;
        const decodedHighlight = highlightParam
          ? (() => {
              try {
                return decodeURIComponent(highlightParam);
              } catch {
                return highlightParam;
              }
            })()
          : null;

        setUrlParams({
          page:
            pageNumber && !isNaN(pageNumber) && pageNumber > 0
              ? pageNumber
              : null,
          highlight: decodedHighlight,
        });
      }

      // Check if URL parameter exists
      // if (urlString.includes("url=")) {
      //   // Try URLSearchParams first (works if URL is properly encoded)
      //   pdfUrl = params.get("url");

      //   // If URLSearchParams returned something, check if it might be truncated
      //   // (e.g., if the original URL had unencoded & characters)
      //   // We detect this by checking if there are other params that might have been part of the URL
      //   if (pdfUrl && params.toString().includes("url=")) {
      //     // Count how many unique keys we have
      //     const allKeys = Array.from(params.keys());
      //     // If we have more params than just 'url', and the url doesn't look complete,
      //     // it might be truncated - try regex fallback
      //     if (allKeys.length > 1 || !pdfUrl.startsWith('http')) {
      //       // Try regex to get the full URL
      //       const urlMatch = urlString.match(/[?&]url=(.+)$/);
      //       if (urlMatch && urlMatch[1].length > pdfUrl.length) {
      //         pdfUrl = urlMatch[1];
      //       }
      //     }
      //   }

      //   // If URLSearchParams didn't return anything, try regex
      //   if (!pdfUrl) {
      //     // Extract everything after ?url= or &url= until the end
      //     const urlMatch = urlString.match(/[?&]url=(.+)$/);
      //     if (urlMatch) {
      //       pdfUrl = urlMatch[1];
      //     }
      //   }
      // }

      if (pdfUrl) {
        // Decode the URL - it may be encoded
        let decodedUrl = pdfUrl;
        try {
          decodedUrl = decodeURIComponent(pdfUrl);
        } catch {
          // If decode fails, use as-is (might already be decoded)
          decodedUrl = pdfUrl;
        }

        // Encode query parameters properly (preserve + characters)
        try {
          const queryIndex = decodedUrl.indexOf("?");
          if (queryIndex !== -1) {
            const baseUrl = decodedUrl.substring(0, queryIndex);
            const queryString = decodedUrl.substring(queryIndex + 1);
            // Manually parse query string to preserve + characters
            const pairs = queryString.split("&");

            const encodedPairs = pairs.map((pair) => {
              const equalIndex = pair.indexOf("=");
              if (equalIndex === -1) {
                return encodeURIComponent(pair);
              }
              const key = pair.substring(0, equalIndex);
              const value = pair.substring(equalIndex + 1);
              return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            });
            decodedUrl = `${baseUrl}?${encodedPairs.join("&")}`;
          }
        } catch {
          // If encoding fails, use decoded URL as-is
        }

        // Extract filename from URL (before query params if any)
        const urlWithoutParams = decodedUrl.split("?")[0];
        const filename = urlWithoutParams.split("/").pop() || "document.pdf";

        console.log("Parsed PDF URL from query parameter:", decodedUrl);
        console.log("Extracted filename:", filename);

        setFile({
          name: filename,
          url: decodedUrl,
        });
      }
    }
  }, []);

  const onFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileUrl = URL.createObjectURL(file);
      setFile({
        name: file.name,
        url: fileUrl,
      });
    }
  };

  // const onClearFile = () => {
  //   setFile({
  //     name: null,
  //     url: null,
  //   });
  //   // Clear URL parameter when clearing file
  //   const url = new URL(window.location.href);
  //   url.searchParams.delete("url");
  //   window.history.replaceState({}, "", url.toString());
  // };

  return (
    <div>
      <div className="@container flex h-full w-full flex-col">
        {file.name == null && (
          <div className="bg-black p-2">
            <input type="file" onChange={onFileChange} />
          </div>
        )}
        {file.url != null && (
          <div className="flex h-full flex-col min-h-0">
            <Toolbar fileName={file.name} fileUrl={file.url} />
            <CustomPDFViewer
              fileUrl={file.url}
              initialPage={urlParams.page}
              initialHighlight={urlParams.highlight}
            />
          </div>
        )}
      </div>
      <ThumbNailViewer />
    </div>
  );
}

export default App;
